import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { StudioScreen } from './StudioScreen';

/**
 * The Promote / Studio route. Every call is account-scoped. The key starts a new screen for each
 * artist, so the draft (the song, the format, the theme, the details) of the old artist goes.
 */
const StudioViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <StudioScreen key={accountId} accountId={accountId} />;
};

export const StudioView = TypedMemo(StudioViewComponent);
